import React from "react";
import VASGraph from "../../../../components/feedback/VASGraph";
import { toVoiceAssessmentVASGraphProps } from "../reference-feedback/voiceAssessmentGraphPresentation";
import FeedbackMetricSummary from "../reference-feedback/FeedbackMetricSummary";
import { observedRangeInterpretation } from "../reference-feedback/ContinuousReferenceFeedback";

const formatOneDecimal = value => Number(value).toFixed(1).replace(/\.0$/, "");

function SourceEvidence({ constructLabel, roleLabel, evidence, sourceLabel, learnerValue, interpretRange = false }) {
  if (!evidence) return null;
  const rangeInterpretation = interpretRange
    ? observedRangeInterpretation(learnerValue, evidence)
    : null;
  const accessibleLabel = roleLabel
    ? `${roleLabel} ${constructLabel} source evidence`
    : `${constructLabel} source evidence`;
  return (
    <section className={`av-source-evidence${roleLabel ? " av-source-evidence--grouped" : ""}`} aria-label={accessibleLabel}>
      {roleLabel && <h5>{roleLabel}: {sourceLabel || evidence.sourceId}</h5>}
      {evidence.values?.length > 0 && <VASGraph
        {...toVoiceAssessmentVASGraphProps({
          attributeName: constructLabel,
          learnerValue,
          referenceValues: evidence.values,
        })}
        ariaLabel={`${roleLabel ? `${roleLabel} ` : ""}${constructLabel} learner and PVQD reference ratings`}
      />}
      {rangeInterpretation && <p className="av-continuous-feedback__range-interpretation">{rangeInterpretation}</p>}
      <FeedbackMetricSummary items={[
        { label: "Your rating", value: formatOneDecimal(learnerValue) },
        { label: "Central value", value: formatOneDecimal(evidence.centralValue) },
        { label: "Spread (SD)", value: evidence.spread === undefined ? "Not available" : formatOneDecimal(evidence.spread) },
      ]} />
    </section>
  );
}

export default function AmbiguityDistributionFeedback({ projection, getConstructLabel, primarySourceLabel, secondarySourceLabel, headingHelp }) {
  if (!projection) return null;
  const ratedProjections = projection.projections.filter(item => item.learnerValue !== null && item.learnerValue !== undefined);
  const hasGraph = ratedProjections.some(item => item.primary?.values?.length > 0 || item.secondary?.values?.length > 0);
  return (
    <section className="av-ambiguity-feedback" aria-label="Distribution-aware feedback">
      <div className="av-methodology-heading">
        <h3>Reference feedback</h3>
        {headingHelp}
      </div>
      {hasGraph && <p className="av-ambiguity-feedback__summary">In this stage, pay attention to how much the expert ratings vary. The full spread is meaningful evidence; there may not be one uniquely correct rating.</p>}
      {ratedProjections.map(item => {
        const constructLabel = getConstructLabel?.(item.constructId) || item.constructId;
        const hasSecondary = Boolean(item.secondary);
        return (
          <article className="av-ambiguity-feedback__item" key={item.constructId}>
            <h4>{constructLabel}</h4>
            <SourceEvidence constructLabel={constructLabel} roleLabel={hasSecondary ? "Primary" : null} evidence={item.primary} sourceLabel={primarySourceLabel} learnerValue={item.learnerValue} interpretRange />
            <SourceEvidence constructLabel={constructLabel} roleLabel="Secondary / cross-validation" evidence={item.secondary} sourceLabel={secondarySourceLabel} learnerValue={item.learnerValue} />
          </article>
        );
      })}
    </section>
  );
}
